import { Input, Directive } from "@angular/core";

@Directive()
export abstract class CTAButtonFeaturesLayout<T> {
	// abstract layoutContext: T;
	@Input() abstract context: T;
}
